
            export default {
              mounted() {
                const hidden = this.el.querySelector("[data-otp-value]");
                const slots = [...this.el.querySelectorAll("[data-otp-slot]")];
                const sync = () => { hidden.value = slots.map((s) => s.value).join(""); };
                slots.forEach((slot, i) => {
                  slot.addEventListener("input", () => {
                    slot.value = slot.value.replace(/\D/g, "").slice(0, 1);
                    if (slot.value && slots[i + 1]) slots[i + 1].focus();
                    sync();
                  });
                  slot.addEventListener("keydown", (e) => {
                    if (e.key === "Backspace" && !slot.value && slots[i - 1]) slots[i - 1].focus();
                  });
                  slot.addEventListener("paste", (e) => {
                    e.preventDefault();
                    const digits = (e.clipboardData.getData("text") || "")
                      .replace(/\D/g, "")
                      .slice(0, slots.length)
                      .split("");
                    digits.forEach((d, j) => { if (slots[j]) slots[j].value = d; });
                    sync();
                    (slots[Math.min(digits.length, slots.length - 1)] || slot).focus();
                  });
                });
                slots[0]?.focus();
              },
            };
          